<template>
  <transition name="modal-animation">
    <div v-show="modalActive" class="modal">
      <transition name="modal-animation-inner">
        <div v-show="modalActive" class="modal-inner fadeAGML2 show">
          <div class="header-modal">
          <h3 class="text-uppercase">{{titulo ? titulo : 'OPPS...'}}</h3>
          <i @click="close" class="far fa-times-circle"></i>
          </div>
          <!-- Modal Content -->
          <slot />
        </div>
      </transition>
    </div>
  </transition>
</template>

<script>
export default {
  props: ["modalActive", 'titulo'],
  setup(props, { emit }) {
    const close = () => {
      emit("close");
    };
    return { close };
  },
};
</script>

<style lang="scss" scoped>
.modal-animation-enter-active,
.modal-animation-leave-active {
  transition: opacity 0.3s cubic-bezier(0.52, 0.02, 0.19, 1.02);
}
.modal-animation-enter-from,
.modal-animation-leave-to {
  opacity: 0;
}
.modal-animation-inner-enter-active {
  transition: all 0.3s cubic-bezier(0.52, 0.02, 0.19, 1.02) 0.15s;
}
.modal-animation-inner-leave-active {
  transition: all 0.3s cubic-bezier(0.52, 0.02, 0.19, 1.02);
}
.modal-animation-inner-enter-from {
  opacity: 0;
  transform: scale(0.8);
}
.modal-animation-inner-leave-to {
  transform: scale(0.8);
}
.modal {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  width: 100vw;
  position: fixed;
  top: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.7);
  .modal-inner {
    position: relative;
    border-radius: 12px;
    max-width: 640px;
    width: 80%;
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
    background-color: #fff;
    padding: 90px 16px;
    h3{
      position: absolute;
      top: 15px;
      left: 15px;
      font-size: 20px;
    }
    i {
      position: absolute;
      top: 15px;
      right: 15px;
      font-size: 2rem;
      cursor: pointer;
      transition: 0.3s all;
      &:hover {
        color: crimson;
      }
    }
  }
  @media(max-width: 370px){
    .modal-inner{
      h3{
        font-size: 1rem;
      }
    }
  }
}
</style>